export enum Role {
    Influencer = 'influencer',
    Company = 'company'
  }